import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import {
    Big_Shoulders,
    DM_Mono,
    DM_Sans,
    Fraunces
} from 'next/font/google'

const sans = DM_Sans({
    subsets: ['latin'],
    axes: ['opsz']
})

const mono = DM_Mono({
    subsets: ['latin'],
    weight: ['400', '500']
})

const heading = Big_Shoulders({
    subsets: ['latin'],
    axes: ['opsz']
})

const serif = Fraunces({
    subsets: ['latin'],
    style: ['normal', 'italic'],
    axes: ['SOFT', 'WONK', 'opsz']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily};--font-app-serif:${serif.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
